var map = {
	"./Harbor_1.png": 1315
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1314;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/harbor ^\.\/Harbor_.*\.png$
// module id = 1314
// module chunks = 3